module.exports = __webpack_public_path__ + "static/media/webview-demo.0cf690a9.mp4";